import { Link } from "react-router-dom";

import { Button } from "@/components/ui/button";
import { formatDisplayNameString } from "@/lib/nameFormatters";


export const PortalShell = ({ title, eyebrow, children, session, onLogout, homeLink, navLinks = [] }) => {
  const brand = {
    primary_dark: "var(--brand-primary-dark, #2B2B2B)",
    primary_orange: "var(--brand-primary-orange, #F5A623)",
    white: "var(--brand-white, #FFFFFF)",
    offwhite: "var(--brand-offwhite, #F7F5F1)",
  };

  return (
    <div className="min-h-screen text-slate-900" style={{ background: "linear-gradient(180deg, var(--brand-offwhite, #F7F5F1) 0%, #fbfaf7 100%)" }}>
      <header className="border-b border-stone-200 bg-white/85 backdrop-blur-lg">
        <div className="mx-auto flex w-full max-w-7xl flex-wrap items-center justify-between gap-4 px-4 py-5 sm:px-6 lg:px-8">
          <div>
            <p className="text-xs font-semibold uppercase tracking-[0.28em]" style={{ color: brand.primary_orange }} data-testid="portal-eyebrow-text">
              {eyebrow}
            </p>
            <h1 className="mt-2 text-3xl font-semibold leading-tight tracking-[-0.02em] text-slate-950" data-testid="portal-title-text">
              {title}
            </h1>
            <p className="mt-1 text-sm text-slate-600" data-testid="portal-session-name-text">
              Signed in as {formatDisplayNameString(session?.display_name || "")}
            </p>
          </div>

          <div className="flex flex-wrap items-center gap-2">
            {navLinks.map((link) => (
              <Button key={link.to} asChild variant="outline" className="rounded-full bg-transparent" style={{ borderColor: brand.primary_orange, color: brand.primary_dark }} data-testid={link.testId}>
                <Link to={link.to}>{link.label}</Link>
              </Button>
            ))}
            {title === "Module reader" ? (
              <Button asChild variant="outline" className="rounded-full bg-transparent" style={{ borderColor: brand.primary_orange, color: brand.primary_dark }} data-testid="portal-back-to-profile-button">
                <Link to="/student">Back to profile</Link>
              </Button>
            ) : null}
            <Button asChild variant="outline" className="rounded-full bg-transparent" style={{ borderColor: brand.primary_orange, color: brand.primary_dark }} data-testid="portal-home-link-button">
              <Link to={homeLink}>Back to website</Link>
            </Button>
            <Button onClick={onLogout} className="rounded-full" style={{ backgroundColor: brand.primary_dark, color: brand.white }} data-testid="portal-logout-button">
              Sign out
            </Button>
          </div>
        </div>
      </header>

      <main className="mx-auto w-full max-w-7xl px-4 py-10 sm:px-6 lg:px-8">{children}</main>
    </div>
  );
};